import { IComponentOptions } from 'angular';
import controller from './modal.controller';
import template from './modal.html';

/**
 * @type {IComponentOptions}
 */
const component = {
	template,
	transclude: {
		title: '?modalTitle',
		body: '?modalBody',
		footer: '?modalFooter',
	},
	controller,
};

export default component;
